<div class="tour-title-wrapper">
    <span class="tour-title">{{'Zimmertyp' | i18n | async}}</span>
</div>

<ng-container *ngTemplateOutlet="roomTypeListEx?.length > 0 ? extern : all"></ng-container>

<ng-template #extern>
    <div class="tour-wrapper">
        <ng-container *ngFor="let item of roomTypeListEx | slice:0:slicenbr">
            <button class="tour-item-wrapper-ext" (click)="selected(item)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedList.indexOf(item.code) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <div class="bestprc">
                    <span class="tour-item-name-ext">{{item.name | i18n | async}}</span>
                    <span class="bestprcit">{{'ab' | i18n | async}} {{item.bestPricePerPerson?.value + ' ' +
                        item.bestPricePerPerson?.currency}} p.P.</span>
                </div>
            </button>
        </ng-container>
        <ng-container *ngIf="roomTypeListEx.length > 5">
            <ng-container *ngIf="(slicenbr < roomTypeListEx.length) else less">
                <button class="showallbtn" (click)="showMore(roomTypeListEx.length)" matRipple>
                    <span>{{'alle' | i18n | async}} {{roomTypeListEx.length}} {{'anzeigen' | i18n | async}}</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span>{{'weniger anzeigen' | i18n | async}}</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>

<ng-template #all>
    <div class="tour-wrapper" *ngIf="roomTypeList?.length > 0">
        <ng-container *ngFor="let op of roomTypeList| slice:0:slicenbr">
            <button class="tour-item-wrapper" (click)="selected(op)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedList.indexOf(op.code) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <span class="tour-item-name">{{op.name | i18n | async}}</span>
            </button>
        </ng-container>
        <ng-container *ngIf="roomTypeList.length > 5">
            <ng-container *ngIf="(slicenbr < roomTypeList.length) else less">
                <button class="showallbtn" (click)="showMore(roomTypeList.length)" matRipple>
                    <span>{{'alle' | i18n | async}} {{roomTypeList.length}} {{'anzeigen' | i18n | async}}</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span>{{'weniger anzeigen' | i18n | async}}</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>